export default {"src":"/_next/static/media/tg.01c0bf0c.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};